import React from "react";

import { FormattedMessage } from "gatsby-plugin-intl";
import nationalTransferAnimation from "images/services/national.mp4";
import internationalTransferAnimation from "images/services/international.mp4";
import billPaymentAnimation from "images/services/billPayment.mp4";
import refillAnimation from "images/services/refill.mp4";
import transportAnimation from "images/services/transport.mp4";
import insuranceAnimation from "images/services/insurance.mp4";
import exchangeAnimation from "images/services/exchange.mp4";
import taxesAnimation from "images/services/taxes.mp4";
import ServiceLink from "components/ServicesModals/ServiceLink";

export const SERVICES_KEYS = {
  NATIONAL_TRANSFER: "NATIONAL_TRANSFER",
  INTERNATIONAL_TRANSFER: "INTERNATIONAL_TRANSFER",
  EXCHANGE: "EXCHANGE",
  BILL_PAYMENT: "BILL_PAYMENT",
  INSURANCE_AND_CNSS: "INSURANCE_AND_CNSS",
  TICKETING_AND_TRANSPORTATION: "TICKETING_AND_TRANSPORTATION",
  TAXES: "TAXES",
  REFILL: "REFILL",
};

export const SERVICES_LIST = [
  {
    title: <FormattedMessage id="chaabiServices.nationalTransfer.title" />,
    description: (
      <FormattedMessage id="chaabiServices.nationalTransfer.description" />
    ),
    btnText: <FormattedMessage id="branches.findBranch" />,
    animationSrc: nationalTransferAnimation,
    key: SERVICES_KEYS.NATIONAL_TRANSFER,
    path: "/#branches",
    triggersModal: false,
  },
  {
    component: ServiceLink,
    title: <FormattedMessage id="chaabiServices.internationalTransfer.title" />,
    description: (
      <FormattedMessage id="chaabiServices.internationalTransfer.description" />
    ),
    btnText: <FormattedMessage id="services.text-button" />,
    animationSrc: internationalTransferAnimation,
    key: SERVICES_KEYS.INTERNATIONAL_TRANSFER,
    path: "/#services",
    triggersModal: true,
  },
  {
    title: <FormattedMessage id="chaabiServices.exchange.title" />,
    description: <FormattedMessage id="chaabiServices.exchange.description" />,
    btnText: <FormattedMessage id="branches.findBranch" />,
    animationSrc: exchangeAnimation,
    key: SERVICES_KEYS.EXCHANGE,
    path: "/#branches",
    triggersModal: false,
  },
  {
    component: ServiceLink,
    title: <FormattedMessage id="chaabiServices.billPayment.title" />,
    description: (
      <FormattedMessage id="chaabiServices.billPayment.description" />
    ),
    btnText: <FormattedMessage id="services.text-button" />,
    animationSrc: billPaymentAnimation,
    key: SERVICES_KEYS.BILL_PAYMENT,
    path: "/#services",
    triggersModal: true,
  },
  {
    component: ServiceLink,
    title: <FormattedMessage id="chaabiServices.insuranceAndCNSS.title" />,
    description: (
      <FormattedMessage id="chaabiServices.insuranceAndCNSS.description" />
    ),
    btnText: <FormattedMessage id="services.text-button" />,
    animationSrc: insuranceAnimation,
    key: SERVICES_KEYS.INSURANCE_AND_CNSS,
    path: "/#services",
    triggersModal: true,
  },
  {
    component: ServiceLink,
    title: (
      <FormattedMessage id="chaabiServices.ticketingAndTransportation.title" />
    ),
    description: (
      <FormattedMessage id="chaabiServices.ticketingAndTransportation.description" />
    ),
    btnText: <FormattedMessage id="services.text-button" />,
    animationSrc: transportAnimation,
    key: SERVICES_KEYS.TICKETING_AND_TRANSPORTATION,
    path: "/#services",
    triggersModal: true,
  },
  {
    component: ServiceLink,
    title: <FormattedMessage id="chaabiServices.taxes.title" />,
    description: <FormattedMessage id="chaabiServices.taxes.description" />,
    btnText: <FormattedMessage id="services.text-button" />,
    animationSrc: taxesAnimation,
    key: SERVICES_KEYS.TAXES,
    path: "/#services",
    triggersModal: true,
  },
  {
    component: ServiceLink,
    title: <FormattedMessage id="chaabiServices.refill.title" />,
    description: <FormattedMessage id="chaabiServices.refill.description" />,
    btnText: <FormattedMessage id="services.text-button" />,
    animationSrc: refillAnimation,
    key: SERVICES_KEYS.REFILL,
    path: "/#services",
    triggersModal: true,
  },
];
